import {
    TEST,
    SET_AUTHORIZATION_STATUS,
    GET_LATEST_NEWS_STARTED,
    GET_LATEST_NEWS_SUCCESS,
    GET_LATEST_NEWS_FAILURE,
    GET_POST_STARTED,
    GET_POST_SUCCESS,
    GET_POST_FAILURE,
    GET_NONCE_STARTED,
    GET_NONCE_SUCCESS,
    GET_NONCE_FAILURE,
    LOGIN_STARTED,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_WITH_HONEE_STARTED,
    LOGIN_WITH_HONEE_SUCCESS,
    LOGIN_WITH_HONEE_FAILURE,
    SEND_IDO_FORM_STARTED,
    SEND_IDO_FORM_FAILURE,
    SEND_IDO_FORM_SUCCESS
} from "./types";


const initialState = {
    test: false,
    authorizationStatus: !!localStorage.getItem('lp-token'),
    latestNewsStarted: false,
    latestNews: false,
    latestNewsErr: false,
    postStarted: false,
    post: false,
    postErr: false,
    nonceStarted: false,
    nonce: false,
    nonceErr: false,
    loginStatusStarted: false,
    loginStatus: false,
    loginStatusErr: false,
    loginWithHoneeStatusStarted: false,
    loginWithHoneeStatus: false,
    loginWithHoneeStatusErr: false,
    idoFormStatusStarted: false,
    idoFormStatus: false,
    idoFormStatusErr: false,
    isComingSoon: false
};

export function mainReducer(state = initialState, action) {
    switch (action.type) {
        case TEST:
            return {
                ...state,
                test: action.payload
            };
        case SET_AUTHORIZATION_STATUS:
            return {
                ...state,
                authorizationStatus: action.payload
            };
        case GET_LATEST_NEWS_STARTED:
            return {
                ...state,
                latestNewsStarted: true
            };
        case GET_LATEST_NEWS_SUCCESS:
            return {
                ...state,
                latestNews: action.payload,
                latestNewsStarted: false
            };
        case GET_LATEST_NEWS_FAILURE:
            return {
                ...state,
                latestNewsErr: action.payload,
                latestNewsStarted: false
            };
        case GET_POST_STARTED:
            return {
                ...state,
                postStarted: true
            };
        case GET_POST_SUCCESS:
            return {
                ...state,
                post: action.payload,
                postStarted: false
            };
        case GET_POST_FAILURE:
            return {
                ...state,
                postErr: action.payload,
                postStarted: false
            };
        case GET_NONCE_STARTED:
            return {
                ...state,
                nonceStarted: true
            };
        case GET_NONCE_SUCCESS:
            return {
                ...state,
                nonce: action.payload,
                nonceStarted: false
            };
        case GET_NONCE_FAILURE:
            return {
                ...state,
                nonceErr: action.payload,
                nonceStarted: false
            };
        case LOGIN_STARTED:
            return {
                ...state,
                loginStatusStarted: true
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                loginStatus: action.payload,
                loginStatusStarted: false
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                loginStatusErr: action.payload,
                loginStatusStarted: false
            };
        case LOGIN_WITH_HONEE_STARTED:
            return {
                ...state,
                loginWithHoneeStatusStarted: true
            };
        case LOGIN_WITH_HONEE_SUCCESS:
            return {
                ...state,
                loginWithHoneeStatus: action.payload,
                loginWithHoneeStatusStarted: false
            };
        case LOGIN_WITH_HONEE_FAILURE:
            return {
                ...state,
                loginWithHoneeStatusErr: action.payload,
                loginWithHoneeStatusStarted: false
            };
        case SEND_IDO_FORM_STARTED:
            return {
                ...state,
                idoFormStatusStarted: true
            };
        case SEND_IDO_FORM_SUCCESS:
            return {
                ...state,
                idoFormStatus: action.payload,
                idoFormStatusStarted: false
            };
        case SEND_IDO_FORM_FAILURE:
            return {
                ...state,
                idoFormStatusErr: action.payload,
                idoFormStatusStarted: false
            };
        default:
            return state;
    }
}

